import { useQuery } from 'react-query';
import { EventParticipationAPI } from 'api/eventParticipation';
import { EVENT_PARTICIPATION } from 'helpers/constants';

export default function useParticipantEventParticipation(id) {
  return useQuery([EVENT_PARTICIPATION, id], () =>
    EventParticipationAPI.getAllForParticipant(id)
  );
}
